module.exports = __webpack_public_path__ + "static/media/textediter_link_active.e2b077fd.svg";